'use strict';

$(document.body).prepend('<div class="svg-icon-map" style="display: none;"></div>');

$.get(window.mogo.registry.mogoUI.config.resourcePaths.assetsPath + '/imgs/svg-sprite.svg?cb=' + cache_bust_timestamp, function (data) {
  $('.svg-icon-map').append(new XMLSerializer().serializeToString(data.documentElement));
});

$.get(window.mogo.registry.mogoUI.config.resourcePaths.assetsPath + '/mogo-ui-lib-min/icons/mogo-ui-lib-svg-sprite.svg?cb=' + cache_bust_timestamp, function (data) {
  $('.svg-icon-map').append(new XMLSerializer().serializeToString(data.documentElement));
});